import { createContext, useContext } from 'react';
import useMixpanel, { IUseMixpanelProps } from '.';
import combineTrackingData from './combine-tracking-data';

export const mixpanelContext = createContext<IUseMixpanelProps | null>(null);

export default function MixpanelProvider({
  children,
  mixpanel,
}: {
  children: React.ReactNode;
  mixpanel: IUseMixpanelProps;
}) {
  const context = useContext<IUseMixpanelProps | null>(mixpanelContext);

  const data = combineTrackingData(mixpanel, context);

  useMixpanel(mixpanel);

  return (
    <mixpanelContext.Provider value={data}>{children}</mixpanelContext.Provider>
  );
}
